module.exports = __webpack_public_path__ + "static/tt-67f1bc78ff706d323fafef98833175cb.jpeg";